// Slash-command parsing without DOM or network dependencies, so chat UI and
// tests agree on aliases and target handling.
const CHAT_COMMAND_NAMES = Object.freeze([
  'help',
  'commands',
  'stats',
  'fps',
  'ping',
  'who',
  'mute',
  'unmute',
  'kick',
  'ban',
  'spec',
  'spectate',
  'live',
  'play',
  'stop'
]);

const CHAT_COMMAND_NAME_SET = new Set(CHAT_COMMAND_NAMES);

function normalizeChatCommandTarget(rawTarget) {
  const target = String(rawTarget || '').trim().replace(/^@/, '').trim();
  return target.slice(0, 32);
}

function parseChatCommand(rawText) {
  const text = String(rawText || '').trim();
  const match = text.match(/^\/([a-z]+)(?:\s+([\s\S]*))?$/i);
  if (!match) return null;
  const name = match[1].toLowerCase();
  if (!CHAT_COMMAND_NAME_SET.has(name)) return null;
  const args = String(match[2] || '').trim();
  return {
    name,
    args,
    target: normalizeChatCommandTarget(args)
  };
}

export {
  CHAT_COMMAND_NAMES,
  normalizeChatCommandTarget,
  parseChatCommand
};
